<template>
  <div
    :id="`toast-${uid}`"
    class="toast fade m-auto mb-1 mb-md-3 ms-md-auto me-md-3"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    data-bs-autohide="false"
  >
    <div class="custom-toast-body bg-secondary text-bg-secondary cow-toast-info">
      <div
        class="spinner-border spinner-border-sm me-2"
        role="status"
      />
      <strong class="me-auto">{{ message }}</strong>
      <button
        type="button"
        class="btn-close me-1"
        data-bs-dismiss="toast"
        aria-label="Close"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import Toast from 'bootstrap/js/dist/toast';
import { useUid } from '@app/composables/useUid';

defineProps<{
  message: string;
}>();

const uid = useUid();

onMounted(() => {
  const toast = document.getElementById(`toast-${uid}`);
  if (toast) {
    // eslint-disable-next-line no-new
    new Toast(toast).show();
  }
});
</script>

<style scoped>
.custom-toast-body {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  border-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
</style>
